(function(app) {
    app.provider("personApi",
    [
        function() {
            this.$get = [
                "crmApiGateway", function(crmApiGateway) {
                    var service = {};

                    //GETs
                    service.searchPeople = function(term) {
                        return crmApiGateway.getArray("/People/Search?q=" + term);
                    };

                    service.get = function(personId) {
                        return crmApiGateway.get("/People/" + personId);
                    };

                    service.getAllPeople = function() {
                        return crmApiGateway.getArray("/People");
                    };

                    service.getSsn = function(personId) {
                        return crmApiGateway.get("/People/" + personId + "/SSN");
                    };

                    service.getPhoneNumbers = function (personId) {
                        return crmApiGateway.getArray("/People/" + personId + "/PhoneNumbers");
                    };

                    service.getPrimaryPhoneNumber = function(personId) {
                        return crmApiGateway.get("/People/" + personId + "/PhoneNumbers/Primary");
                    };

                    service.getEmailAddresses = function(personId) {
                        return crmApiGateway.getArray("/People/" + personId + "/EmailAddresses");
                    };

                    service.getPhysicalAddresses = function(personId) {
                        return crmApiGateway.getArray("/People/" + personId + "/PhysicalAddresses");
                    }

                    service.getProfilePicture = function(personId) {
                        return crmApiGateway.getFile("/People/" + personId + "/ProfilePicture", {headers: {"Accept":"image/*"} });
                    };

                    //PUTs
                    service.update = function(person) {
                        return crmApiGateway.put("/People/" + person.Id, person);
                    };

                    service.updateSsn = function(personId, ssn) {
                        return crmApiGateway.put("/People/" + personId + "/SSN", ssn);
                    };

                    service.updatePhoneNumber = function(personId, phoneNumber) {
                        return crmApiGateway.put("/People/" + personId + "/PhoneNumbers/" + phoneNumber.Id, phoneNumber);
                    };

                    service.updateEmailAddress = function(personId, emailAddress) {
                        return crmApiGateway.put("/People/" + personId + "/EmailAddresses/" + emailAddress.Id, emailAddress);
                    };

                    service.updatePhysicalAddress = function(personId, physicalAddress) {
                        return crmApiGateway.put("/People/" + personId + "/PhysicalAddresses/" + physicalAddress.Id, physicalAddress);
                    };

                    service.updatePrimaryPhoneNumber = function(personId, phoneNumber) {
                        return crmApiGateway.put("/People/" + personId + "/PhoneNumbers/Primary", phoneNumber);
                    };

                    service.updatePrimaryEmailAddress = function(personId, emailAddress) {
                        return crmApiGateway.put("/People/" + personId + "/EmailAddresses/Primary", emailAddress);
                    };

                    service.updatePrimaryPhysicalAddress = function(personId, physicalAddress) {
                        return crmApiGateway.put("/People/" + personId + "/PhysicalAddresses/Primary", physicalAddress);
                    };

                    service.updatePreferredCommunication = function(personId, preferredCommunication) {
                        return crmApiGateway.put("/People/" + personId + "/PreferredCommunication", preferredCommunication);
                    };


                    //POSTs
                    service.add = function(person) {
                        return crmApiGateway.post("/People", person);
                    };

                    service.addPhoneNumber = function(personId, phoneNumber) {
                        return crmApiGateway.post("/People/" + personId + "/PhoneNumbers", phoneNumber);
                    };

                    service.addEmailAddress = function(personId, emailAddress) {
                        return crmApiGateway.post("/People/" + personId + "/EmailAddresses", emailAddress);
                    };

                    service.addPhysicalAddress = function(personId, physicalAddress) {
                        return crmApiGateway.post("/People/" + personId + "/PhysicalAddresses", physicalAddress);
                    };

                    service.updateProfilePicture = function(personId, photo) {
                        return crmApiGateway.postFile("/People/" + personId + "/ProfilePicture", photo);
                    };
                    service.AddAllContactInfo = function (personId, allContactInfo) {
                        return crmApiGateway.post("/People/" + personId + "/ContactInfo", allContactInfo);
                    };

                    //DELETEs
                    service.delete = function(personId) {
                        return crmApiGateway.delete("/People/" + personId);
                    }

                    service.removeSsn = function(personId) {
                        return crmApiGateway.delete("/People/" + personId + "/SSN");
                    };

                    service.removePhoneNumber = function(personId, phoneNumber) {
                        return crmApiGateway.delete("/People/" + personId + "/PhoneNumbers/" + phoneNumber.Id);
                    };

                    service.removeEmailAddress = function(personId, emailAddress) {
                        return crmApiGateway.delete("/People/" + personId + "/EmailAddresses/" + emailAddress.Id);
                    };

                    service.removePhysicalAddress = function(personId, physicalAddress) {
                        return crmApiGateway.delete("/People/" + personId + "/PhysicalAddresses/" + physicalAddress.Id);
                    };

                    service.removePrimaryPhoneNumber = function(personId) {
                        return crmApiGateway.delete("/People/" + personId + "/PhoneNumbers/Primary");
                    };

                    service.removePrimaryEmailAddress = function(personId) {
                        return crmApiGateway.delete("/People/" + personId + "/EmailAddresses/Primary");
                    };

                    service.removePrimaryPhysicalAddress = function(personId) {
                        return crmApiGateway.delete("/People/" + personId + "/PhysicalAddresses/Primary");
                    };

                    service.removeProfilePicture = function(personId) {
                        return crmApiGateway.delete("/People/" + personId + "/ProfilePicture");
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line